import { render, staticRenderFns } from "./search-commission.vue?vue&type=template&id=c63b7756"
import script from "./search-commission.vue?vue&type=script&lang=js"
export * from "./search-commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports